import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import classes from "./SignedInMenu.module.css";
import { Link } from "react-router-dom";
import { openModal } from "../../modals/modalActions";
class SignedInMenu extends Component {
  state = {
    collapse: false
  };

  openProfileClasses = null;
  UserProfileClasses = null;

  handleClick = () => {
    console.log(this.state.collapse);
    this.setState({
      collapse: !this.state.collapse
    });
  };

  // <div className={"dropdown pull-right d-lg-block d-none"}>

  // dropdown-menu dropdown-menu-right profile-dropdown

  render() {
    let { signOut, profile, auth, openModal } = this.props;

    !this.state.collapse
      ? (this.UserProfileClasses =
          "dropdown-menu dropdown-menu-right profile-dropdown")
      : (this.UserProfileClasses =
          "dropdown-menu dropdown-menu-right profile-dropdown show");

    console.log("UserProfileClasses", this.UserProfileClasses);

    return (
      <Fragment>
        <a
          href="http://internal.prepaidplus.co.bw"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.NewPortalLink}
        >
          New Portal
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="12px"
            width="12px"
            viewBox="0 0 24 24"
            style={{ marginLeft: '6px', verticalAlign: 'middle' }}
          >
            <path
              fill="#002060"
              d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
            />
          </svg>
        </a>
        {profile && profile.userType === "PrepaidPlus" && (
          <a
            href="https://ppp-troubleshooting-prod.web.app"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.NewPortalLink}
          >
            Troubleshooting
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="12px"
              width="12px"
              viewBox="0 0 24 24"
              style={{ marginLeft: '6px', verticalAlign: 'middle' }}
            >
              <path
                fill="#002060"
                d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
              />
            </svg>
          </a>
        )}
        <div className={classes.LoginWrapper}>
          Welcome,{" "}
          <span className={classes.LoggedUser}>{profile.displayName}</span>
          <div className={"dropdown pull-right d-lg-block d-none"}>
            <button
              className={"profile-dropdown-toggle"}
              style={{ marginLeft: "5px" }}
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              onClick={() => this.handleClick()}
            >
              <span className={"inline"}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="7.388"
                  width="12"
                  viewBox="0 0 12 7.388"
                >
                  <g>
                    <path
                      fill="#002060"
                      d="M2.137,0,5.962,3.488,9.9.037,12,1.95,6,7.388,0,1.95Z"
                    />
                  </g>
                </svg>
              </span>
            </button>

            <div
              className={this.UserProfileClasses}
              role="menu"
              x-placement="bottom-end"
            >
      

              <span
                className={"dropdown-item"}
                onClick={() => openModal("ChangeUserPasswordModal")}
              >
                Change Password
              </span>
              <span
                className={"dropdown-item"}
                onClick={() => openModal("ChangeUserNameModal")}
              >
                Change Name(s)
              </span>

              <span
                className={"clearfix bg-master-lighter dropdown-item"}
                onClick={signOut}
              >
                <span className={"pull-left"}>Logout</span>
                <span className={"pull-right"}>
                  <i className={"pg-power"} />
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className={classes.SettingsIconWrapper}>
          <svg
            focusable="false"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                id="path1"
                transform="rotate(0,12,12) translate(7.15255737304688E-07,0) scale(0.75,0.75)  "
                fill="#002060"
                d="M16.000015,9.6000061C12.500012,9.6000061 9.5999844,12.5 9.5999844,16 9.5999844,19.5 12.500012,22.399994 16.000015,22.399994 19.500019,22.399994 22.400015,19.5 22.400015,16 22.400015,12.5 19.500019,9.6000061 16.000015,9.6000061z M14.199995,0L17.800005,0C18.199999,0,18.599993,0.29998779,18.599993,0.79998779L18.599993,4.7999878C19.900013,5.1000061,21.000019,5.6000061,22.099997,6.2999878L25.000023,3.3999939C25.099999,3.2999878 25.300011,3.1999817 25.500025,3.1999817 25.700007,3.1999817 25.900019,3.2999878 26.000025,3.3999939L28.600033,6C28.900021,6.2999878,28.900021,6.7999878,28.600033,7.1000061L25.700007,10C26.400019,11.100006,26.900019,12.299988,27.200007,13.5L31.20001,13.5C31.600037,13.5,31.999998,13.799988,31.999998,14.299988L31.999998,17.899994C31.999998,18.299988,31.700012,18.699982,31.20001,18.699982L27.200007,18.699982C26.900019,20,26.400019,21.100006,25.700007,22.199982L28.600033,25.100006C28.700009,25.199982 28.799984,25.399994 28.799984,25.600006 28.799984,25.799988 28.700009,26 28.600033,26.100006L26.000025,28.600006C25.900019,28.699982 25.700007,28.799988 25.500025,28.799988 25.300011,28.799988 25.099999,28.699982 25.000023,28.600006L22.099997,25.699982C21.000019,26.399994,19.800007,26.899994,18.599993,27.199982L18.599993,31.199982C18.599993,31.600006,18.300005,32,17.800005,32L14.199995,32C13.8,32,13.400006,31.699982,13.400006,31.199982L13.400006,27.199982C12.099987,26.899994,11.000011,26.399994,9.9000027,25.699982L7.0000064,28.600006C6.9000003,28.699982 6.6999881,28.799988 6.5000059,28.799988 6.2999937,28.799988 6.099981,28.699982 6.0000054,28.600006L3.3999967,26C3.0999784,25.699982,3.0999784,25.199982,3.3999967,24.899994L6.2999937,22C5.5999805,20.899994,5.0999801,19.699982,4.7999923,18.5L0.79998828,18.5C0.39999409,18.5,-1.933513E-07,18.199982,0,17.699982L0,14.100006C-1.933513E-07,13.699982,0.2999879,13.299988,0.79998828,13.299988L4.7999923,13.299988C5.0999801,12,5.5999805,10.899994,6.2999937,9.7999878L3.3999967,7C3.2999908,6.8999939 3.1999845,6.6999817 3.1999845,6.5 3.1999845,6.2999878 3.2999908,6.1000061 3.3999967,6L6.0000054,3.3999939C6.099981,3.2999878 6.2999937,3.1999817 6.5000059,3.1999817 6.6999881,3.1999817 6.9000003,3.2999878 7.0000064,3.3999939L9.9000027,6.2999878C11.000011,5.6000061,12.199993,5.1000061,13.400006,4.7999878L13.400006,0.79998779C13.400006,0.29998779,13.8,0,14.199995,0z"
              />
            </g>
          </svg>
        </div>
        <div className={classes.SettingsHelpIconWrapper}>
          <svg
            focusable="false"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="path1"
              transform="rotate(0,12,12) translate(0,0) scale(0.75,0.75) "
              fill="#002060"
              d="M14.580002,23.394012L14.580002,26.235001 17.18399,26.235001 17.18399,23.394012z M16.117996,5.7660065C14.539993,5.7660065 13.278992,6.2390137 12.332993,7.1880035 10.991989,8.5250092 10.320999,10.223007 10.320999,12.27301L13.043991,12.27301C13.043991,10.695007 13.437988,9.5130005 14.22699,8.7230072 14.697998,8.25 15.289001,8.0130005 16,8.0130005 16.867996,8.0130005 17.537003,8.25 18.009995,8.7230072 18.561996,9.2750092 18.838989,10.106003 18.838989,11.207001 18.838989,12.077011 18.522995,12.827011 17.89299,13.455002 16.789001,14.561005 16.039001,15.429001 15.644989,16.061005 15.090988,16.92601 14.817001,18.228012 14.817001,19.964005L16.947998,19.964005C16.947998,18.545013 17.302002,17.478012 18.009995,16.767014 18.955994,15.824005 19.705994,15.074005 20.259995,14.522003 21.205002,13.574005 21.679001,12.432007 21.679001,11.090012 21.679001,9.5130005 21.166,8.2109985 20.14299,7.1880035 19.194992,6.2390137 17.853989,5.7660065 16.117996,5.7660065z M16,0C24.819992,0 32,7.178009 32,16.001007 32,24.822006 24.819992,32 16,32 7.1759949,32 0,24.822006 0,16.001007 0,7.178009 7.1759949,0 16,0z"
            />
          </svg>
        </div>
      </Fragment>
    );
  }
}

const actions = {
  openModal
};

// export default connect(null,actions)(Outlet);

// export default Outlet;
export default connect(
  null,
  actions
)(SignedInMenu);
